<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>MarketPro</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <user-count />
                </v-col>
                <v-col cols="3">
                  <account-count />
                </v-col>
                <v-col cols="3">
                  <order-count />
                </v-col>
                <v-col cols="3">
                  <turnover />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <open-orders />
        </v-col>
        <v-col cols="4">
          <v-card elevation="0">
            <v-card-title>Crédits</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <favorite-service />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <order-evolution />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <last-users />
        </v-col>
        <v-col cols="8">
          <service-usage />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UserCount from "@/components/dashboard/UserCount.vue";
import AccountCount from "@/components/dashboard/AccountCount.vue";
import OrderCount from "@/components/dashboard/OrderCount.vue";
import Turnover from "@/components/dashboard/Turnover.vue";
import OpenOrders from "@/components/dashboard/OpenOrders.vue";
import FavoriteService from "@/components/dashboard/FavoriteService.vue";
import ServiceUsage from "@/components/dashboard/ServiceUsage.vue";
import LastUsers from "@/components/dashboard/LastUsers.vue";
import OrderEvolution from "@/components/dashboard/OrderEvolution.vue";
export default {
  components: {
    UserCount,
    AccountCount,
    OrderCount,
    Turnover,
    OpenOrders,
    FavoriteService,
    ServiceUsage,
    LastUsers,
    OrderEvolution
  },
  data: () => ({
    options: {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    },
    chartdata: {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Commandes",
          fill: false,
          borderColor: "#0a252c",
          data: [40, 20, 30, 400]
        }
      ]
    }
  })
};
</script>

<style>
</style>